export const ON_FILTER_IS_OPEN = 'filters@ON_FILTER_IS_OPEN'
export const ON_FILTER_IS_CLOSE = 'filters@ON_FILTER_IS_CLOSE'
export const ON_FILTER_SORT_FIELD_CHANGED =
  'filters@ON_FILTER_SORT_FIELD_CHANGED'
export const ON_FILTER_SORT_ORIENTATION_CHANGED =
  'filters@ON_FILTER_SORT_ORIENTATION_CHANGED'
export const ON_ADD_FILTER_QUERY = 'filters@ON_ADD_FILTER_QUERY'
export const ON_EDIT_FILTER_QUERY = 'filters@ON_EDIT_FILTER_QUERY'
export const ON_REMOVE_FILTER_QUERY = 'filters@ON_REMOVE_FILTER_QUERY'
export const ON_SET_SEARCH = 'filters@ON_SET_SEARCH'
export const ON_CLEAR = 'filters@ON_CLEAR'
